import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { normalizeSportsbookRankingRows } from "./normalizeSportsbookRankingRows";

type StoredToken = { AccessToken?: string };

export type SportsbookByStateFilters = {
  start_date: string;
  end_date: string;
};

export type SportsbookStateRow = {
  name: string;
  abbr: string;
  turnover: number;
  pnl: number;
  margin_pct: number;
  total_bets: number;
  avg_bet_amount: number;
  total_users: number;
};

const fetchSportsbookByState = async (
  filters: SportsbookByStateFilters,
): Promise<SportsbookStateRow[]> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const response = await instance.get(API_ROUTES.SPORTSBOOK_BY_STATE, {
    params: filters,
  });
  return normalizeSportsbookRankingRows(response?.data?.data).map((row) => ({
    name: row.name,
    abbr: row.abbr ?? row.name.slice(0, 2).toUpperCase(),
    turnover: row.turnover.value,
    pnl: row.pnl.value,
    margin_pct: row.margin_pct.value,
    total_bets: row.total_bets.value,
    avg_bet_amount: row.avg_bet_amount.value,
    total_users: row.total_users.value,
  }));
};

export const useGetSportsbookByState = (filters: SportsbookByStateFilters) => {
  const { start_date, end_date } = filters;

  return useQuery<SportsbookStateRow[], Error>({
    queryKey: ["SPORTSBOOK_BY_STATE", start_date, end_date],
    queryFn: () => fetchSportsbookByState(filters),
    enabled: Boolean(start_date && end_date),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
